<template>
  <div class="menu-user-dropdown item-avatar" :class="{'remove-click': hasUserInfo}" @click.stop>
    <div v-if="!isDesktop && !displayUserInfo">
      <template v-if="avatarUrl === ''">
        <vs-avatar class="sender__avatar flex-shrink-0 mr-3" :size="size" :src="require('@/assets/images/portrait/small/avatar-default.jpg')"/>
        <span v-if="!isCardView">Por {{username}}</span>
      </template>
      <template v-else>
        <vs-avatar class="sender__avatar flex-shrink-0 mr-3" :size="size" :src="avatarUrl"/>
        <span v-if="!isCardView">Por {{username}}</span>
      </template>
    </div>

    <div v-if="isDesktop">
      <template v-if="avatarUrl === ''">
        <vs-avatar class="sender__avatar flex-shrink-0 mr-3" :size="size" :src="require('@/assets/images/portrait/small/avatar-default.jpg')"/>
        <span v-if="!isCardView">Por {{username}}</span>
      </template>
      <template v-else>
            <!-- trigger="hover" -->
          <popper
            :append-to-body="true"
            trigger="click"
            :options="{placement: 'right', modifiers: { offset: { offset: '0,10px' } } }">
            <div class="popper">
              <ul style="min-width: 9rem">
                <li class="flex py-2 px-4 items-center">
                  <vs-avatar 
                    class="sender__avatar flex-shrink-0 mr-3"
                    size="80px"
                    :src="avatarUrl"
                  />
                  <div class="exact-fit text-left">
                    <span>
                      <b>{{username}}</b>: <span class="text-right">{{resume}}</span>
                    </span>
                  </div>
                </li>
              </ul>

            </div>
            <button slot="reference" class="button-avatar flex">
              <vs-avatar class="sender__avatar flex-shrink-0 mr-3" :size="size" :src="avatarUrl" />
              <span style="align-self: center" v-if="!isCardView">Por {{username}}</span>
            </button>
          </popper>
      </template>
    </div>
  </div>
</template>

<script>
  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/vue-popper.css';

  export default {
    props: {
      avatarUrl: {
        type: String
      },
      username: {
        type: String, required: true
      },
      resume: {
        type: String, required: true
      },
      isDesktop: {
        type: Boolean, required: true
      },
      isCardView: {
        type: Boolean, default: false
      },
      displayUserInfo: false, 
      size: {
        type: String, required: false, default: "30px"
      }
    },
    data() {
      return {};
    },
    components: {
      'popper': Popper,
    },
    computed: {
      hasUserInfo() {
        return this.username === '';
      }
    },
    methods: {
      onClick(e) {
        e.preventDefault()
        console.log(e);
      }
    }
  };
</script>

<style lang="scss">
  .remove-click {
    pointer-events: none;
  }

  #header-dropdown-menu-user {
    .vs-dropdown--menu {
      left: calc(100% - 110px);
    }
  }

  .button-avatar {
    background: none;
    box-shadow: 0 0 0 transparent;
    border: 0 solid transparent;
    text-shadow: 0 0 0 transparent;
  }

  .theme-dark .popper {
    background: #282e34;
    border-color: #4d5762;
    color: #fff;
  }
</style>
